module.exports = __webpack_public_path__ + "static/2-2f9665c7210711a739b98edc04fffa05.png";